import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ButtonLinkComponent, IconComponent, ButtonComponent } from '@mode/capra';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'mode-dataset-publish-success',
  templateUrl: './dataset-publish-success.component.html',
  styleUrls: ['./dataset-publish-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
  imports: [SharedUtilToastModule, ButtonLinkComponent, IconComponent, ButtonComponent],
  standalone: true,
})
export class DatasetPublishSuccessComponent extends Toast {
  thoughtspotDataWorkspaceLink = this.options.payload.thoughtspotDataWorkspaceLink;

  dismissToast() {
    this.remove();
  }
}
